// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2OdJ5","sendOtp":"AuthorizeToLogin_sendOtp__23auW"};